import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { FocusedInlineCommentQuery } from './FocusedInlineCommentQuery.graphql';

export function preloadFocusedInlineComment(commentId: string, contentId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: FocusedInlineCommentQuery,
		variables: {
			commentId,
			contentId,
		},
	});
}
